import * as React from 'react'

import { Box, Tag } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const EmptyCell = () => {
  return (
    <Box flexDirection="row" alignItems="center">
      <Tag type={Tag.Types.grey5}>
        {i18n.t('shift_management.templates.weeks.settings_empty_cell.title')}
      </Tag>
    </Box>
  )
}

export default EmptyCell
